import { render, staticRenderFns } from "./BKCurrencyInput.vue?vue&type=template&id=5e5ebd25"
import script from "./BKCurrencyInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./BKCurrencyInput.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports